import { useViewScoreStore } from "@/store/viewScoreStore";
import { WeaveCheckbox } from "../UI/WeaveCheckbox/WeaveCheckbox"
import styles from './styles.module.scss'
import { MultiSelect } from "../UI/MultiSelect/MultiSelect";
import { HorizonContext } from "@/types/horizonContext";

export const BeyondHorizonSettings = () => {
	const { isBeyondHorizonEnabled, setIsBeyondHorizonEnabled, horizonContexts, setHorizonContexts } = useViewScoreStore();

	const horizonContextOptions = Object.values(HorizonContext).map((context) => ({
		label: context,
		value: context,
	}));

	const handleHorizonContextsChange = (selectedValues: string[]) => {
		setHorizonContexts(selectedValues as HorizonContext[]);
	};

	return (
		<div>
			<div className={styles.horizonToggle}>
				<WeaveCheckbox
					checked={isBeyondHorizonEnabled}
					label="Enable Beyond Horizon Assumptions"
					showLabel={true}
					change={() => setIsBeyondHorizonEnabled(!isBeyondHorizonEnabled)}
				/>
			</div>
			{isBeyondHorizonEnabled && (
				<div className={styles.horizonSelect}>
					<label>Select Horizon Contexts (multiple)</label>
					<MultiSelect
						options={horizonContextOptions}
						selectedValues={horizonContexts}
						onChange={handleHorizonContextsChange}
						width="200px"
					/>
				</div>
			)}
		</div>
	)
}